/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  useState, useCallback,
  useMemo,
  useEffect,
} from 'react';
import {
  Button, Container, Inline, ComboBox, Modal, Typography, Row, Col, Radio, Badge, RadioGroup,
  Spinner,
} from '@airbus/components-react';
import './GenericColumnLevelFilter.scss';
import { Close, Tune } from '@airbus/icons/react';
import {
  FILTER, DATA_FILTER_TITLE, FILTER_BY, SORT_BY, APPLY, CLEAR, COMBOBOX_PLACEHOLDER,
  NODATA_FILTER,
} from '../../../utils/constants';
import { toggleFilterModel, updateCheckerDetailsColumnFilterState } from '../../../models/checkerDetailsModel/checkerDetailsSlice';
import ColumnLevelFilter from './ColumnLevelFilter';

interface ColumFilterProps {
  tableProps: any;
}
const GenericColumnLevelFilter: React.FC<ColumFilterProps> = (props: ColumFilterProps) => {
  const { tableProps } = props;
  const {
    dispatcher, validateHandler, uncheckClfState, showFilterPanel, currentSelectedFilters, loadFilterOptionsHandler, filterColumns, showNoData = false, popupFilterState, tableState,
  } = tableProps;

  const [tableFilters, setTableFilters] = useState<Record<string, Array<string>>>(currentSelectedFilters);
  const [sortOrder, setSortOrder] = useState('DESC');
  const [sortByColumn, setSortByColumn] = useState<string>('');
  const [stateCount, setStateCount] = useState<number>(0);
  const [showNoDataChild, setShowNoDataChild] = useState<boolean>(showNoData);
  useEffect(() => {
    setShowNoDataChild(showNoData);
  }, [showNoData]);

  useEffect(() => {
    setTableFilters(currentSelectedFilters);
  }, [currentSelectedFilters]);

  const appliedFiltersCount = useMemo(() => {
    const filtersCount = Object.values(tableFilters).filter((arr: any) => arr.length > 0).length;
    setStateCount(filtersCount);
    return filtersCount;
  }, [tableFilters]);

  const getSortableColumns = (columnsObject: Array<any>) => {
    return columnsObject.filter((column: any) => column.isSortableColumn).map((item: any) => item.Header);
  };
  /* istanbul ignore next */
  /* Open combo form event */
  const handleOpen = () => {
    dispatcher(toggleFilterModel(true));
    setShowNoDataChild(false);
  };
  /* istanbul ignore next */
  /* Sort By selection event function */
  const handleSortBySelection = (selectedValue: any) => {
  // Store selectedValue (Header) directly
    setSortByColumn(selectedValue);
  };
  /* Close combo form by event  */
  const handleClose = () => {
    dispatcher(toggleFilterModel(false));
    setStateCount(appliedFiltersCount);
  };
  useEffect(() => {
    setSortByColumn('');
  }, [popupFilterState?.fleet_detail_filter_selected?.selected_msn]);
  /* Clear selected values by event  */
  const handleClearFilter = () => {
    dispatcher(uncheckClfState());
    validateHandler({});
    setSortByColumn('');
  };

  useEffect(() => {
    if (showFilterPanel && loadFilterOptionsHandler) {
      setTableFilters({ ...currentSelectedFilters });
      loadFilterOptionsHandler();
    }
  }, [showFilterPanel, loadFilterOptionsHandler, currentSelectedFilters]);

  const setConditionsObj = useCallback((conditions: any) => {
    const filters = { ...tableFilters, ...conditions };
    setTableFilters(filters);
  }, [tableFilters]);

  return (
    <div>
      <Container data-testid="popup-filter-modal">
        <Button size="small" variant="primary" className="data-filter-button" onClick={handleOpen} icon={<Tune />} data-testid="CLF-button" placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          {FILTER}
          {stateCount !== 0 && <Badge className="filter-count" count={stateCount} aria-label="" />}
        </Button>
        <Modal id="column-filter-id" className="data-filter-popup-container" aria-labelledby="modal-title" aria-describedby="modal-description" open={showFilterPanel}>
          <div className="filter-container">
            <Container className="parent-model-class">
              <Row className="filterSort-header-label">
                <Col xxs={8} className="filer-sort-header-title">
                  <Inline spacing="1-x">
                    <Tune className="filter-icon-color" />
                    <Typography variant="medium">{DATA_FILTER_TITLE}</Typography>
                  </Inline>
                </Col>
                <Col xxs={3}>
                  <Close className="modal-close-icon" onClick={handleClose} data-testid="modal-close" />
                </Col>
              </Row>
              <Row>
                {showNoDataChild && <Typography variant="medium" className="nodata-label">{NODATA_FILTER}</Typography>}
              </Row>
              {
                filterColumns.groupProps.isLoading ? (
                  <div className="column-level-spinner">
                    <Container className="column-spinner">
                      <Spinner size="medium" />
                    </Container>
                    <Typography variant="small" className="column-spinner">Please wait, downloading data...</Typography>
                  </div>
                ) : (
                  <>
                    <Row className="tilte-header-filterby">
                      <Col xxs={3}>
                        <Typography variant="small" className="filterby-header-label">
                          {FILTER_BY}
                        </Typography>
                      </Col>
                    </Row>
                    <ColumnLevelFilter filterProps={tableProps} updateConditionsObj={setConditionsObj} />
                    <Row className="tilte-header-sortby">
                      <Col xxs={3}>
                        <Typography variant="small" className="dynamic-header">
                          {SORT_BY}
                        </Typography>
                      </Col>
                      <Col className="dynamic-header-outside">
                        <ComboBox
                          aria-label="Sort By"
                          size="small"
                          placeholder={COMBOBOX_PLACEHOLDER}
                          options={getSortableColumns(tableProps.filterColumns.columnProps)}
                          value={sortByColumn}
                          onChange={(value: any) => handleSortBySelection(value)}
                          hideClear
                          data-testid="table-column-test-id"
                        />
                      </Col>
                      <Col className="sort-by">
                        <Inline spacing="4-x">
                          <RadioGroup value={sortOrder} onChange={(e, value) => setSortOrder(value)} className="radio-group-genric">
                            <Radio label="Ascending" value="ASC" className="asc-radio" />
                            <Radio label="Descending" value="DESC" />
                          </RadioGroup>
                        </Inline>
                      </Col>
                    </Row>
                  </>
                )
              }
              <Inline spacing="1-x" align="end" className="clear-apply-button">
                {/* istanbul ignore next */}
                <Button size="small" disabled={!sortByColumn.length && appliedFiltersCount === 0} variant="secondary" data-testid="modal-reset" onClick={handleClearFilter} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                  {CLEAR}
                </Button>
                <Button
                  size="small"
                  /* istanbul ignore next */
                  disabled={!sortByColumn.length && (appliedFiltersCount === 0 && showNoDataChild === false)}
                  className="apply-button"
                  variant="primary"
                  onClick={() => {
                    setStateCount(appliedFiltersCount);
                    // Find filterName for selected Header
                    const selectedColumn = tableProps.filterColumns.columnProps.find((x: any) => x.Header === sortByColumn);
                    const sortByFilterName = selectedColumn ? selectedColumn.filterName : '';
                    validateHandler(tableFilters, currentSelectedFilters, sortByFilterName, sortOrder);
                    handleClose();
                    dispatcher(updateCheckerDetailsColumnFilterState({ ...tableState.filterState, fin_status: [] }));
                  }}
                  data-testid="modal-apply"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                >
                  {APPLY}
                </Button>
              </Inline>
            </Container>
          </div>
        </Modal>
      </Container>
    </div>
  );
};
export default GenericColumnLevelFilter;
